module.exports = __webpack_public_path__ + "res/Roboto-ThinItalic-webfont.woff?165e68ef131b8053d4471605b9532485";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-ThinItalic-webfont.woff
// module id = 58
// module chunks = 0